import { Button, Select } from 'antd';
import React from 'react';
import { Gap, Flex, Icon } from '@common/components';
import { DetailItemAttachmentType } from '@onboarding/graphql';
import { AttachmentSelectorStatusIcon } from './_file-viewer-attachment-selector-status-icon';

type AttachmentSelectorProps = {
  sourceAttachments: DetailItemAttachmentType[];
  selectedAttachment: DetailItemAttachmentType | undefined;
  onChange: (fileId: string) => void;
  onEdit?: (fileId: string) => void;
};

export const AttachmentSelector = ({
  sourceAttachments,
  selectedAttachment,
  onChange,
  onEdit,
}: AttachmentSelectorProps) => (
  <Gap align="center" fullWidth>
    <Select
      size="large"
      style={{ width: '100%' }}
      placeholder="Select a file..."
      value={selectedAttachment?.id}
      onChange={onChange}
    >
      {sourceAttachments.map(
        ({ id, file: { downloadUrl, filename }, status }) => {
          return (
            <Select.Option key={downloadUrl} value={id} title={filename}>
              <AttachmentSelectorStatusIcon status={status} /> {filename}
            </Select.Option>
          );
        }
      )}
    </Select>

    {selectedAttachment?.id && onEdit && (
      <Button type="link" onClick={() => onEdit(selectedAttachment.id)}>
        <Flex align="center">
          <Icon icon="pen" color="elm" />
        </Flex>
      </Button>
    )}

    <a
      data-testid="download-link"
      href={selectedAttachment?.file.downloadUrl || undefined}
    >
      <Button type="link" size="large">
        <Flex align="center">
          <Icon icon="download" kind="solid" />
        </Flex>
      </Button>
    </a>
  </Gap>
);
